import { css } from '@emotion/react';
import { FontSize } from './vendor/_rfs.mixin';
import { Hover } from './mixins/_hover.mixin';
import { BorderRadius } from './mixins/_border-radius.mixin';
import { Transition } from './mixins/_transition.mixin';
import { BadgeVariant } from './mixins/_badge.mixin';

export default $ => {
  return css`
    .badge {
      display: inline-block;
      padding: ${$.badgePaddingY} ${$.badgePaddingX};
      ${new FontSize($.badgeFontSize).include($)};
      font-weight: ${$.badgeFontWeight};
      line-height: 1;
      text-align: center;
      white-space: nowrap;
      vertical-align: baseline;
      ${new BorderRadius($.badgeBorderRadius).include($)};
      ${new Transition($.badgeTransition).include($)};

      &:empty {
        display: none;
      }
    }

    .badge-danger {
      color: #fff;
      background-color: #dc3545;
    }
    .badge-danger[href]:focus,
    .badge-danger[href]:hover {
      color: #fff;
      text-decoration: none;
      background-color: #bd2130;
    }

    a.badge {
      ${new Hover().include(
        $,
        css`
          text-decoration: none;
        `
      )};
    }

    .btn .badge {
      position: relative;
      top: -1px;
    }

    .badge-pill {
      padding-right: ${$.badgePillPaddingX};
      padding-left: ${$.badgePillPaddingX};
      ${new BorderRadius($.badgePillBorderRadius).include($)};
    }


    ${Object.entries($.themeColors).map(([color, value]) => css`
      .badge-${color} {
        ${new BadgeVariant(value).include($)};
      }
      a.badge-${color} {
        ${BadgeVariant.atRoot($, value)};
      }
    `
    )}
  `;
};
